module.exports = __webpack_public_path__ + "static/media/lowresportfolio-18.5ee72b4e.jpg";